import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { useACLCan } from 'app/domains/filesystem';
import { constructSearchURL } from 'app/domains/global-search';
import { ScreenLayout } from 'shared/domains/common-ui/ScreenLayout';
import { FileSystemBreadcrumbs } from './Breadcrumbs';
import { ContextMenuButton } from '../ContextMenuButton';
import { useActiveWorkspace } from '../FileSystemProvider';
export function Header(props) {
    const { onUploadFile, onCreateFolder, onUploadFolder } = props;
    const { fileSystemData } = useActiveWorkspace();
    const { folder } = fileSystemData || {};
    const { mpath = '' } = folder || {};
    const { canWrite } = useACLCan({ userAcls: folder === null || folder === void 0 ? void 0 : folder.acl, teamAcls: folder === null || folder === void 0 ? void 0 : folder.teamAcls });
    const path = constructSearchURL({
        where: {
            metadataEntryPath: {
                startsWith: mpath,
            },
        },
    });
    const searchPath = mpath ? path : '/all-documents';
    return (<ScreenLayout.Topbar breadcrumbs={<FileSystemBreadcrumbs />} actions={<Fragment>
          <Button type="button" size="xs" appearance="secondary" as={Link} to={searchPath}>
            <Falcon icon="magnifying-glass"/>
            <Trans comment="filter and search button text">Filter & Search</Trans>
          </Button>
          <ContextMenuButton disabled={folder ? !canWrite() : false} onUploadFile={onUploadFile} onCreateFolder={onCreateFolder} onUploadFolder={onUploadFolder}/>
        </Fragment>}/>);
}
